import { ReactNode } from 'react';
import { PillButtonStyled } from './pill-button.style';

type Props = {
  isSelected?: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
  noBorder?: boolean;
};

const PillButton = ({
  isSelected,
  disabled,
  onClick,
  children,
  noBorder,
  ...rest
}: Props) => {
  return (
    <PillButtonStyled
      type="button"
      onClick={onClick}
      data-selector={`pill-button${isSelected ? '--selected' : ''}`}
      $isSelected={isSelected}
      disabled={disabled}
      aria-disabled={disabled}
      $noBorder={noBorder}
      {...rest}
    >
      {children}
    </PillButtonStyled>
  );
};

export default PillButton;
